module.exports = __webpack_public_path__ + "static/media/bg-common40c719d9322825a6c786d10eb0ef1c35.webp";